import { ReactNode } from "react";
import AbstractDoc from "../AbstractDoc";

export default class Condizioni_it extends AbstractDoc {

    protected getDoc(): ReactNode {
        return (
            <div>
                <h1>CONDIZIONI D'USO</h1>

                Benvenuto nel gioco Android (di seguito "il Gioco"). L'accesso e l'utilizzo del Gioco sono soggetti alle seguenti Condizioni d'Uso ("CdU"). L'utilizzo del Gioco implica la piena accettazione delle CdU da parte dell'utente.

                <h2>LICENZA D'USO</h2>
                Il Gioco è protetto dai diritti di proprietà intellettuale e dall'ordinamento giuridico applicabile. L'autore del Gioco concede all'utente una licenza d'uso personale, non trasferibile e non esclusiva per utilizzare il Gioco, compatibilmente con le presenti CdU. L'utente non ha alcun diritto di utilizzo del Gioco non espressamente contemplato nelle presenti CdU.

                <h2>MODIFICHE DELLE CDU</h2>
                L'autore del Gioco si riserva il diritto di modificare, aggiornare o integrare le CdU in qualsiasi momento e a propria discrezione, senza obbligo di preavviso all'utente. L'utente è tenuto a verificare periodicamente le CdU per verificare eventuali modifiche. L'eventuale utilizzo del Gioco successivamente alle modifiche apportate alle CdU implica la piena accettazione delle stesse da parte dell'utente.
                
                <h2>MAGGIORE ETA'</h2>
                L'utente dichiara di aver compiuto la maggiore età
                
                <h2>CONDIZIONI D'ACCESSO E UTILIZZO DEL GIOCO</h2>
                L'utente si impegna ad utilizzare il Gioco in conformità alle presenti CdU e alle leggi e norme vigenti. È vietato qualsiasi utilizzo del Gioco a scopo illecito o contrario all'ordine pubblico, al buon costume e alla morale. In particolare, l'utente si impegna a non utilizzare il Gioco per:

                diffondere messaggi offensivi o diffamatori;
                violare i diritti di proprietà intellettuale dell'autore del Gioco o di terzi;
                utilizzare il Gioco per finalità commerciali o pubblicitarie.
                L'utente è responsabile di ogni utilizzo del Gioco connesso al proprio account e si impegna a non condividere con terzi le proprie credenziali di accesso.

                <h2>GARANZIE E RESPONSABILITÀ</h2>
                L'autore del Gioco non garantisce che il Gioco sia privo di errori, virus o altri elementi dannosi per il proprio dispositivo o i propri dati. L'autore del Gioco non assume alcuna responsabilità per eventuali danni subiti dall'utente a causa dell'utilizzo del Gioco.

                <h2>PROPRIETÀ INTELLETTUALE</h2>
                Il Gioco è protetto dai diritti di proprietà intellettuale dell'autore del Gioco. L'utente si impegna a non copiare, modificare, distribuire, diffondere, pubblicare o utilizzare in qualsiasi modo il Gioco o i suoi contenuti senza il previo consenso scritto dell'autore del Gioco.

                <h2>SOSPENSIONE E RECESSO</h2>
                L'autore del Gioco si riserva il diritto di sospendere o revocare la licenza d'uso dell'utente in qualsiasi momento
            </div>
        );
    }

}